import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AddonsPageService {
  private readonly addonsPageEnabledSubject = new BehaviorSubject<boolean>(false);

  get addonsPageEnabled$(): Observable<boolean> {
    return this.addonsPageEnabledSubject.asObservable();
  }

  setAddonsPageEnabled(value: boolean): void {
    this.addonsPageEnabledSubject.next(value);
  }
}
